import { render, staticRenderFns } from "./musicSheet.vue?vue&type=template&id=60f7a50e&scoped=true"
import script from "./musicSheet.vue?vue&type=script&lang=js"
export * from "./musicSheet.vue?vue&type=script&lang=js"
import style0 from "./musicSheet.vue?vue&type=style&index=0&id=60f7a50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f7a50e",
  null
  
)

export default component.exports